import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f841750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ops-handle d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("更多选项")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置筛选")
const _hoisted_4 = {
  class: "pl-10",
  style: {"text-align":"right"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("列表展示")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("语言")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("行业")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("工单归属")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("耗时")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("处理时间")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("关闭时间")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_13 = { class: "mb-10 d-flex align-items-center" }
const _hoisted_14 = { style: {"color":"red","font-weight":"600","font-size":"10px"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("催单")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("提醒关单")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "d-flex align-items-center"
}

import {ref, reactive, computed, onBeforeMount, nextTick, onMounted,shallowRef, onBeforeUnmount,watch} from 'vue'
import { ElMessage, ElMessageBox, genFileId} from 'element-plus'
import { Back, DArrowLeft,Check,Close} from '@element-plus/icons-vue'
import Api from '@/http/modules/index'
import { useRouter,useRoute } from 'vue-router'
import {exportHandle} from '@/utils/index'
import dayjs from "dayjs"

export default /*#__PURE__*/_defineComponent({
  props: {
    listType:{
        default:'Submit',
        type:String
    },
    users:{
        default:[]
    },
    assignedToList:{
        default:[]
    },
    projects:{
        default:[]
    },
    langs:{
        default:[]
    }
},
  emits: ["setTotal"],
  setup(__props, { emit }) {

const props = __props

const {
    // 工单列表
    'POST/tickets/list':getTicketsApi,
    // 下载
    'POST/tickets/export':exportApi,
    // 催单
    'POST/tickets/{id}/remind':remindApi,
    // 耗时
    'PATCH/tickets/duration':durationApi

} = Api

// console.log(props.assignedToList)

let router=useRouter()
let route=useRoute()
const tableHeight=window.innerHeight-200
const showMore=ref(false)
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const queryInfo=ref<any>({
    startTime:dayjs().subtract(30, 'day').format("YYYY-MM-DD"),
    endTime:dayjs().format("YYYY-MM-DD")
})
const ticketLists=ref<any>([])
const dataLoading=ref(false)
const getTickets=(isSearch:boolean=false)=>{
    if(isSearch){
        pageInfo.page=1
    }
    let {page,size}=pageInfo
    
    let { id,description,projectId,serviceType,industry,srcLang,trgLang,userIds,processIds,statusList,startTime, endTime,}=queryInfo.value
        const duration = dayjs(endTime).diff(dayjs(startTime), 'day');
        if(duration>365){
            ElMessage.warning("最长只能选择一年365天")
            return
        }
    let params:any={
        page,size,
        id, //工单ID 模糊查询
        description,
        projectId,
        serviceType,
        industry,
        srcLang,
        trgLang,
        userIds,
        processIds,
        statusList,
        startTime:startTime?dayjs(startTime).format("YYYY-MM-DD"):'',
        endTime:endTime?dayjs(endTime).format("YYYY-MM-DD"):'',
    }
    if(props.listType!="All"){ //空=all, 0=提交 , 1=负责
        params.type=props.listType=="Submit"?0:1    
    }
    dataLoading.value=true
    getTicketsApi(params).then((res:any)=>{ 
        ticketLists.value=res.data
        pageInfo.total=res.rowCount
        dataLoading.value=false
        if(props.listType=="Responsible"){
            emit('setTotal',res.newQuantity)
        }
    }).catch(()=>{
        dataLoading.value=false
    })
}
const pageChange=()=>{
    getTickets()
}
const desHandle=(row:any)=>{
    let historyName=""
    let routerName=""
    switch(props.listType){
        case "All":
            historyName='ticketAllQueryHistory';
            routerName='AllTicketDetail'
        break;
        case "Responsible":
            historyName='ticketResponsibleQueryHistory';
            routerName='ResponsibleTicketDetail'            
        break;
        case "Submit":
            historyName='ticketSubmitQueryHistory';
            routerName='SubmitTicketDetail';
        break;
    }
    localStorage.setItem(historyName,JSON.stringify({queryInfo:queryInfo.value,pageInfo}))
    router.push({name:routerName,params:{id:row.id}})
}
const downLoading=ref(false)
const downLoad=async()=>{
    downLoading.value=true
    let { id,description,projectId,serviceType,industry,srcLang,trgLang,userIds,processIds,statusList,startTime, endTime,}=queryInfo.value
    let params={id,description,projectId,serviceType,industry,srcLang,trgLang,userIds,processIds,statusList,
    startTime:startTime?dayjs(startTime).format("YYYY-MM-DD"):'', endTime:endTime?dayjs(endTime).format("YYYY-MM-DD"):''}
    await exportHandle(exportApi,params)
    downLoading.value=false
}
const statusList=[
    {value:'New',label:'新工单'},
    {value:'Processed',label:'接受处理'},
    {value:'Unresolved',label:'未解决'},
    {value:'Resolved',label:'已解决'},
    {value:'Closed',label:'已关闭'},
    {value:'Reject',label:'拒绝'},
    {value:'Back',label:'退回'}
]
const filterStatus=(status:string)=>{
    let res =statusList.find((el:any)=>el.value==status)
    return res?res.label:''
}
// const columnList = ref<any>(['lang','industry','projectName'])
const columnList = ref<any>(['projectName'])
const columnFilter=()=>{
    localStorage.setItem('tickets_'+props.listType,JSON.stringify(columnList.value))
}
const isShowColumn=(prop:string)=>{
   return columnList.value.includes(prop)
}
const currentProject=ref({})
const ticketsHandel=(projectId:any)=>{
    let res=props.projects.find((el:any)=>el.projectId==projectId)
    currentProject.value=res||{}
    getTickets()
}
const queryRef=ref()
const resetForm=()=>{
    queryRef.value.resetFields()
    queryInfo.value={
        startTime:dayjs().subtract(30, 'day').format("YYYY-MM-DD"),
        endTime:dayjs().format("YYYY-MM-DD")
    }
    showMore.value=false
    getTickets()
}
const remindHandle=(row:any)=>{
    let {id}=row
    dataLoading.value=true
    remindApi({id}).then(()=>{
        ElMessage.success("操作成功")
    }).finally(()=>{
        dataLoading.value=false
    })
}
const durationHandel=(row:any)=>{
    row.isEdit=true
}
const modifyDuration=(row:any)=>{
    let {id,duration}=row
    let params={
        duration,
        ticketId:id
    }
    durationApi(params).then(()=>{
        ElMessage.success("操作成功")
        row.isEdit=false
    })
}
onMounted(()=>{
    if(localStorage.getItem('tickets_'+props.listType)){
        columnList.value=JSON.parse(localStorage.getItem('tickets_'+props.listType) as any)
    }else{
        // if(props.listType=="Responsible"){
        //     columnList.value.push('duration')
        // }
        if(props.listType=="All"){
            columnList.value.push(...['processTime','closeTime'])
        }
    }
    // 从哪个个页面来的
    let back:any=router.options.history.state.back 
    let queryHistory:any=null
    if(props.listType=='All'&&back.includes('/ticket/all/')){     
        queryHistory= localStorage.getItem('ticketAllQueryHistory')?JSON.parse(localStorage.getItem('ticketAllQueryHistory') as string):null                 
    }
    if(props.listType=='Responsible'&&back.includes('/ticket/responsible/')){     
        queryHistory= localStorage.getItem('ticketResponsibleQueryHistory')?JSON.parse(localStorage.getItem('ticketResponsibleQueryHistory') as string):null                 
    }
    if(props.listType=='Submit'&&back.includes('/ticket/submit/')){     
        queryHistory= localStorage.getItem('ticketSubmitQueryHistory')?JSON.parse(localStorage.getItem('ticketSubmitQueryHistory') as string):null                 
    }
    queryInfo.value=queryHistory? queryHistory.queryInfo : {
        startTime:dayjs().subtract(30, 'day').format("YYYY-MM-DD"),
        endTime:dayjs().format("YYYY-MM-DD")
    }
    pageInfo.page=queryHistory? queryHistory.pageInfo.page:1
    pageInfo.size=queryHistory? queryHistory.pageInfo.size:30 
    getTickets()

})

return (_ctx: any,_cache: any) => {
  const _component_Filter = _resolveComponent("Filter")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Download = _resolveComponent("Download")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!showMore.value)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showMore.value=true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { style: {"margin-right":"2px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_Filter)
                ]),
                _: 1
              }),
              _hoisted_2
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            onClick: resetForm
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { style: {"margin-right":"2px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_Filter)
                ]),
                _: 1
              }),
              _hoisted_3
            ]),
            _: 1
          })),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_dropdown, {
          trigger: "click",
          "hide-on-click": false
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: columnList.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((columnList).value = $event)),
                  onChange: columnFilter
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, { label: "lang" }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, { label: "industry" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, { label: "projectName" }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        (_unref(props).listType=='Responsible')
                          ? (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: 0,
                              label: "duration"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        (_unref(props).listType=='All')
                          ? (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: 0,
                              label: "processTime"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        (_unref(props).listType=='All')
                          ? (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: 0,
                              label: "closeTime"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              style: {"line-height":"32px"},
              link: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Menu)
                  ]),
                  _: 1
                }),
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_unref(props).listType=='All')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            style: {"margin-left":"12px"},
            link: "",
            loading: downLoading.value,
            onClick: downLoad
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { style: {"margin-right":"2px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_Download)
                ]),
                _: 1
              }),
              _hoisted_12
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_form, {
        "label-width": "100",
        "label-position": "right",
        model: queryInfo.value,
        inline: "",
        ref_key: "queryRef",
        ref: queryRef
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "startTime",
            label: "开始时间"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: queryInfo.value.startTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryInfo.value.startTime) = $event)),
                type: "date",
                placeholder: "开始时间",
                style: {"max-width":"214px"},
                onChange: getTickets
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "endTime",
            label: "结束时间"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: queryInfo.value.endTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryInfo.value.endTime) = $event)),
                type: "date",
                placeholder: "结束时间",
                style: {"max-width":"214px"},
                onChange: getTickets
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (showMore.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: "id",
                label: "工单ID"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    style: {"width":"214px"},
                    modelValue: queryInfo.value.id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryInfo.value.id) = $event)),
                    onChange: getTickets
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            prop: "description",
            label: "描述"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"214px"},
                modelValue: queryInfo.value.description,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((queryInfo.value.description) = $event)),
                onChange: getTickets
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (showMore.value&&_unref(props).listType!='Submit')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                prop: "userIds",
                label: "创建人"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: "请选择",
                    "collapse-tags-tooltip": "",
                    "collapse-tags": "",
                    onChange: getTickets,
                    style: {"flex":"1"},
                    multiple: "",
                    filterable: "",
                    modelValue: queryInfo.value.userIds,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryInfo.value.userIds) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).users, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: `${item.realName} (${item.username})`,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showMore.value&&_unref(props).listType!='Responsible')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                prop: "processIds",
                label: "处理人"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: "请选择",
                    "collapse-tags-tooltip": "",
                    "collapse-tags": "",
                    onChange: getTickets,
                    style: {"flex":"1"},
                    multiple: "",
                    filterable: "",
                    modelValue: queryInfo.value.processIds,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((queryInfo.value.processIds) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).assignedToList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.userId,
                          label: `${item.realName} (${item.username})`,
                          value: item.userId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            prop: "description",
            label: "状态"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                placeholder: "请选择",
                "collapse-tags-tooltip": "",
                "collapse-tags": "",
                onChange: getTickets,
                style: {"flex":"1"},
                multiple: "",
                filterable: "",
                modelValue: queryInfo.value.statusList,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((queryInfo.value.statusList) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (showMore.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: "工单归属",
                prop: "projectId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: "请选择",
                    filterable: "",
                    modelValue: queryInfo.value.projectId,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((queryInfo.value.projectId) = $event)),
                    onChange: ticketsHandel,
                    style: {"flex":"1"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).projects, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.projectId,
                          label: item.name,
                          value: item.projectId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                label: "服务类型",
                prop: "serviceType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: "请选择",
                    onChange: getTickets,
                    filterable: "",
                    modelValue: queryInfo.value.serviceType,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((queryInfo.value.serviceType) = $event)),
                    style: {"flex":"1"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentProject.value.typeList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.typeId,
                          label: item.name,
                          value: item.typeId
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 5,
                label: "源语言",
                prop: "srcLang"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: "请选择",
                    onChange: getTickets,
                    "collapse-tags-tooltip": "",
                    "collapse-tags": "",
                    multiple: "",
                    modelValue: queryInfo.value.srcLang,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((queryInfo.value.srcLang) = $event)),
                    filterable: "",
                    style: {"flex":"1"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).langs, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.code,
                          label: item.name,
                          value: item.code
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 6,
                label: "目标语言",
                prop: "trgLang"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: "请选择",
                    onChange: getTickets,
                    multiple: "",
                    "collapse-tags-tooltip": "",
                    "collapse-tags": "",
                    modelValue: queryInfo.value.trgLang,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((queryInfo.value.trgLang) = $event)),
                    filterable: "",
                    style: {"flex":"1"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).langs, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.code,
                          label: item.name,
                          value: item.code
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mb-10",
      "max-height": tableHeight+'px',
      style: {"width":"auto"},
      data: ticketLists.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "id",
          label: "ID",
          width: "100"
        }),
        (_unref(props).listType=='Responsible')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              fixed: "",
              prop: "font",
              align: "right",
              label: " ",
              width: "60"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", _hoisted_14, [
                  _createElementVNode("i", null, _toDisplayString(row.status=='New'?'NEW':''), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "description",
          label: "描述",
          width: "550",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            (_unref(props).listType=='Submit')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  undeline: false,
                  onClick: ($event: any) => (desHandle(row)),
                  class: "des-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.description), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (_unref(props).listType=='Responsible')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 1,
                  undeline: false,
                  onClick: ($event: any) => (desHandle(row)),
                  class: "des-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.description), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (_unref(props).listType=='All')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 2,
                  undeline: false,
                  onClick: ($event: any) => (desHandle(row)),
                  class: "des-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.description), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (row.status=='New'&&_unref(props).listType=='Submit')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 3,
                  onClick: ($event: any) => (remindHandle(row)),
                  class: "ml-10 remind-btn",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (row.status=='Processed'&&_unref(props).listType=='Responsible')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 4,
                  onClick: ($event: any) => (remindHandle(row)),
                  class: "ml-10 remind-btn",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (isShowColumn('projectName'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              width: "200",
              prop: "projectName",
              fixed: "",
              label: "工单归属"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "serviceType",
          label: "服务类型",
          fixed: "",
          width: "260"
        }),
        (isShowColumn('industry'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "industry",
              label: "行业",
              width: "360"
            }))
          : _createCommentVNode("", true),
        (isShowColumn('lang'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "lang",
              label: "语言",
              width: "260"
            }, {
              default: _withCtx(({row}) => [
                (row.srcLang)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(row.srcLang), 1))
                  : _createCommentVNode("", true),
                (row.trgLang)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(row.trgLang), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(props).listType!='Submit')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              prop: "user",
              label: "创建人",
              width: "200"
            }))
          : _createCommentVNode("", true),
        (_unref(props).listType!='Responsible')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              prop: "process",
              label: "处理人",
              width: "150"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(filterStatus(row.status)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "150",
          prop: "createdAt",
          label: "创建时间",
          formatter: (row)=>_unref(dayjs)(row.createdAt).format('YYYY-MM-DD HH:mm')
        }, null, 8, ["formatter"]),
        (_unref(props).listType=='Responsible'&&isShowColumn('duration'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              width: "150",
              prop: "duration",
              label: "耗时"
            }, {
              default: _withCtx(({row}) => [
                (!row.isEdit)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _createTextVNode(_toDisplayString(row.duration) + " ", 1),
                      _createVNode(_component_el_icon, {
                        onClick: ($event: any) => (durationHandel(row)),
                        class: "ml-10 edit-icon",
                        size: 16
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Edit)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (row.isEdit||false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_el_input_number, {
                        precision: 1,
                        modelValue: row.duration,
                        "onUpdate:modelValue": ($event: any) => ((row.duration) = $event),
                        controls: false
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_button, {
                        class: "ml-10",
                        onClick: ($event: any) => (modifyDuration(row)),
                        size: "small",
                        icon: _unref(Check),
                        circle: ""
                      }, null, 8, ["onClick", "icon"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(props).listType=='All'&&isShowColumn('processTime'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 7,
              width: "150",
              prop: "processTime",
              label: "处理时间",
              formatter: (row)=>row.processTime?_unref(dayjs)(row.processTime).format('YYYY-MM-DD HH:mm'):''
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true),
        (_unref(props).listType=='All'&&isShowColumn('closeTime'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 8,
              width: "150",
              prop: "closeTime",
              label: "关闭时间",
              formatter: (row)=>row.closeTime?_unref(dayjs)(row.closeTime).format('YYYY-MM-DD HH:mm'):''
            }, null, 8, ["formatter"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["max-height", "data"])), [
      [_directive_loading, dataLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      layout: "sizes,prev, pager, next,total",
      total: _unref(pageInfo).total,
      onCurrentChange: pageChange,
      "page-sizes": [30, 60, 80, 100, 120],
      currentPage: _unref(pageInfo).page,
      "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[14] || (_cache[14] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      onSizeChange: pageChange
    }, null, 8, ["total", "currentPage", "page-size"])
  ], 64))
}
}

})